import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {GetWorkOsInformation as GetWorkOsInformationQuery} from 'nutshell-graphql-types';

import GET_WORK_OS_INFORMATION from '../queries/get-work-os-information.graphql';

export const useGetWorkOsInformation = () => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetWorkOsInformationQuery, Record<any, any>>(GET_WORK_OS_INFORMATION, {
        fetchPolicy: 'cache-and-network',
    });

    const {workOs} = makeDataDangerous(data);

    return {
        isLoading,
        workOs: workOs || {},
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
